import React from 'react';
import { CTAButton } from './CTAButton';
export function SolutionSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-white py-3 md:py-4 px-3 relative border-b border-gray-200" data-id="element-150">
      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-151">
        <div className="inline-block bg-[#FFF4ED] border-2 border-[#FF6B00] text-[#FF6B00] font-black px-4 py-1 rounded-full mb-2 uppercase tracking-widest text-xs" data-id="element-152">
          💡 SOLUCIÓN
        </div>

        <h2 className="text-xl md:text-3xl font-black text-[#0B1F3A] mb-2 uppercase tracking-tight" data-id="element-153">
          🔥 KIT COMPLETO{' '}
          <span className="text-[#FF6B00]" data-id="element-154">FUNCIONAL LISTO</span>
        </h2>

        <p className="text-sm md:text-base text-gray-600 font-bold mb-3 max-w-xl mx-auto" data-id="element-155">
          Un sistema completo para dejar de pensar tus clases y empezar a
          ejecutarlas.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-1.5 max-w-2xl mx-auto mb-3 text-left" data-id="element-156">
          {[{
          text: '6 tomos (360 págs)',
          icon: '📚'
        }, {
          text: 'Clases listas',
          icon: '✅'
        }, {
          text: 'Circuitos armados',
          icon: '🔄'
        }, {
          text: 'Progresión por niveles',
          icon: '📈'
        }, {
          text: 'Sistema estructurado',
          icon: '⚙️'
        }].map((item, i) => <div key={i} className="flex items-center gap-2 bg-[#F5F5F5] border border-gray-200 p-2 rounded-lg" data-id="element-157">
              <span className="text-lg flex-shrink-0" data-id="element-158">{item.icon}</span>
              <span className="text-[#0B1F3A] font-black text-xs md:text-sm" data-id="element-159">
                {item.text}
              </span>
            </div>)}
        </div>

        <div className="bg-[#0B1F3A] rounded-lg p-2.5 inline-block mb-3" data-id="element-160">
          <p className="text-[#FF6B00] font-black text-sm md:text-base" data-id="element-161">
            👉 Todo organizado para que solo tengas que enseñar.
          </p>
        </div>

        <div className="flex justify-center" data-id="element-162">
          <CTAButton onClick={scrollToPricing} variant="primary" className="px-6 py-3 text-sm" data-id="element-163">
            VER OPCIONES DE COMPRA
          </CTAButton>
        </div>
      </div>
    </section>;
}